import { combineReducers } from 'redux';
import elementWidthReducer from './elementWidthReducer';

export default combineReducers({
  elementWidth: elementWidthReducer,
});
